<div class="simple-card m-t-20">
  <p class="m-t-12">
    {{ 'productCrossReference.searchLabel' | cxTranslate }}
    <span class="icon">
      <tooltip-icon [icon]="iconTypes.INFO" [content]="'productCrossReference.iconInfo' | cxTranslate"></tooltip-icon>
    </span>
  </p>

  <form [formGroup]="form" (submit)="submit()">
    <div class="form-group search-types m-0">
      <div class="form-check m-b-0">
        <input
          id="searchType-begins"
          class="form-check-input m-r-12"
          role="radio"
          type="radio"
          value="STARTS_WITH"
          formControlName="searchType"
          />
          <label class="form-check-label m-0" for="searchType-begins"> {{ 'productCrossReference.begins' | cxTranslate }} </label>
        </div>

        <div class="form-check m-b-0">
          <input
            id="searchType-contains"
            class="form-check-input m-r-12"
            role="radio"
            type="radio"
            value="INCLUDES"
            formControlName="searchType"
            />
            <label class="form-check-label m-0" for="searchType-contains"> {{ 'productCrossReference.contains' | cxTranslate }} </label>
          </div>

          <div class="form-check m-b-0">
            <input
              id="searchType-equals"
              class="form-check-input m-r-12"
              role="radio"
              type="radio"
              value="IS_EXACTLY"
              formControlName="searchType"
              />
              <label class="form-check-label m-0" for="searchType-equals"> {{ 'productCrossReference.equals' | cxTranslate }} </label>
            </div>

            <div class="form-group form-search m-0">
              <label class="h-100 m-0">
                <div class="container-icon">
                  <input
                    class="form-control m-0"
                    type="text"
                    name="search"
                    maxlength="40"
                    placeholder="{{ 'productCrossReference.placeholder' | cxTranslate }}"
                    formControlName="search"
                    />

                    <button class="icon">
                      <span class="material-symbols-outlined"> search </span>
                    </button>
                  </div>
                  <cx-form-errors [control]="form.get('search')"></cx-form-errors>
                </label>
              </div>
            </div>
          </form>
        </div>

        @if ({
          req: req$ | async,
          }; as content) {
          @if (!content.req?.isPristine) {
            <div class="simple-card m-t-20">
              @if (!content.req?.isLoading) {
                @if (!content.req?.hasError) {
                  @if (content.req?.products?.length) {
                    <product-cross-reference-table [PCRList]="content.req?.products!" [isSearched]="isSearched"></product-cross-reference-table>
                  } @else {
                    <p class="text-center ff-bold m-0">
                      {{ 'productCrossReference.noProducts' | cxTranslate }}
                    </p>
                  }
                } @else {
                  <alert [alert]="alertMessage"></alert>
                }
              } @else {
                <local-loader></local-loader>
              }
            </div>
          }
        }
